module.exports = __webpack_public_path__ + "files/83bd3290b9f12a29d71382f70f47e862.png";